import { render, staticRenderFns } from "./IntegrationsView.vue?vue&type=template&id=20067dda"
import script from "./IntegrationsView.vue?vue&type=script&lang=js"
export * from "./IntegrationsView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsView.vue?vue&type=style&index=0&id=20067dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports